import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { useT } from "@/lib/i18n";

const KEY = "fk_cookies_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const t = useT();

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (mode) => {
    localStorage.setItem(KEY, JSON.stringify({ mode, at: new Date().toISOString() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed z-[55] bottom-6 right-6 left-6 sm:left-auto sm:max-w-[440px] bg-[#121214] border border-white/15 shadow-2xl"
    >
      <div className="p-5 md:p-6">
        <div className="flex items-start gap-3 mb-3">
          <Cookie className="w-4 h-4 text-zinc-400 mt-0.5 flex-none" strokeWidth={1.5} />
          <div className="overline">{t("cookie.label", "— Datenschutz")}</div>
          <button
            type="button"
            onClick={() => accept("essential")}
            aria-label={t("common.close", "Schliessen")}
            className="ml-auto -mt-1 -mr-1 p-1 text-zinc-500 hover:text-white"
          >
            <X className="w-4 h-4" strokeWidth={1.5} />
          </button>
        </div>
        <p className="text-sm text-zinc-300 leading-relaxed mb-4">
          {t(
            "cookie.body",
            "Diese Website verwendet ausschliesslich technisch notwendige Cookies sowie anonyme Statistik, um die Nutzung kontinuierlich zu verbessern. Es werden keine Daten an Dritte verkauft."
          )}{" "}
          <a
            href="/datenschutz"
            className="text-white underline underline-offset-2 hover:no-underline"
          >
            {t("cookie.privacy_link", "Datenschutzerklärung lesen")}
          </a>
          .
        </p>
        <div className="flex flex-col sm:flex-row gap-2">
          <button
            type="button"
            onClick={() => accept("essential")}
            data-testid="cookie-essential"
            className="px-4 py-2.5 text-sm border border-white/20 text-zinc-200 hover:bg-white/5 transition-colors"
          >
            {t("cookie.essential", "Nur notwendige")}
          </button>
          <button
            type="button"
            onClick={() => accept("all")}
            data-testid="cookie-accept-all"
            className="px-4 py-2.5 text-sm bg-white text-black font-semibold hover:bg-zinc-200 transition-colors"
          >
            {t("cookie.accept_all", "Alle akzeptieren")}
          </button>
        </div>
      </div>
    </div>
  );
}
